// test1273
(1273 && 0);
